/* eslint-disable no-use-before-define */
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React from 'react'
import { show, mediaQueries, getConfig } from '../../twd'
import { onMouseOverFn, onMouseOutFn } from './tooltip'
import STATES from './states'

export const svgCss = css`
    .clickable { cursor:pointer; }

    min-width: 741px;
    ${mediaQueries.notXs} {
        width: 100%;
    }
`

export default ({ values={} } = {}) => {
    return <svg height="453"
        aria-hidden="true"
        viewBox="0 0 741 453" fill="none"
        xmlns="http://www.w3.org/2000/svg" css={svgCss}>
    {
        Object.entries(STATES)
        .map( ([state,svgFn], i) => {
            let v = values[state] || {state}
            let n = v.tradeCount || 0
            let c = getColor(n)
            let lc = getLabelColor(n)

            let t = {
                onClick: (e) => onClick({state}),
                onMouseOver: (e) => onMouseOverFn(e, {state, ...v}),
                onMouseOut: (e) => onMouseOutFn(e),
                'id': `municipal-map-${state}`,
                'data-name': 'municipal-map-state',
                'data-tooltip-id': `municipal-map-${state}-label`,
                'data-state': state,
            }

            let lt = {
                onClick: (e) => onClick({state}),
                onMouseOver: (e) => onMouseOverFn(e, {state, ...v}),
                onMouseOut: (e) => onMouseOutFn(e),
                'data-state': state,
                'data-name': 'municipal-map-state-label',
                'data-tooltip-id': `municipal-map-${state}-label`,
                'id': `municipal-map-${state}-label`,

            }

            return <React.Fragment key={i}>
                {svgFn({color:c, labelColor:lc, labelTooltip:lt, tooltip:t})}
                </React.Fragment>
        })
    }

    <path d="M476.76 257.397C476.641 257.443 476.613 257.507 476.613 257.58C476.604 257.672 476.714 257.809 476.815 257.938C476.87 258.002 476.925 258.075 476.97 258.148C476.998 258.148 477.025 258.148 477.053 258.148C477.309 258.148 477.309 258.139 477.364 257.993C477.428 257.828 477.401 257.617 477.309 257.516C477.208 257.388 476.943 257.333 476.76 257.397Z"
    fill="#391B8D"/>

    <path d="M640.137 193.902C640.448 194.085 640.732 194.259 640.961 194.735C641.016 194.845 641.062 194.964 641.098 195.083L641.877 193.911L641.666 193.783C641.273 193.545 640.87 193.298 640.467 193.078C640.384 193.032 640.32 192.995 640.265 192.959C640.21 192.931 640.146 192.885 640.128 192.885C639.999 193.032 639.862 193.307 639.761 193.526C639.743 193.554 639.734 193.581 639.716 193.609C639.771 193.646 639.825 193.691 639.88 193.728C639.963 193.792 640.054 193.847 640.137 193.902Z"
    fill="#825FE2"/>


    <path d="M501.405 232.56C501.386 232.532 501.377 232.505 501.359 232.477C501.341 232.45 501.258 232.386 501.203 232.34C501.121 232.276 501.038 232.202 500.965 232.12C500.965 232.138 500.956 232.166 500.956 232.184C500.928 232.331 500.883 232.633 500.883 232.798C500.983 232.825 501.112 232.862 501.203 232.88C501.24 232.807 501.377 232.624 501.405 232.56Z"
    fill="#825FE2"/>


    </svg>
}

export const getColor = (n) => {
    const isBlue = getConfig('entitlements.ETradeBlue', 'No') === 'Yes'
    if (isBlue) {
        return n > 1000 ? '#00172b' :
            n > 500 ? '#002b51' :
            n > 250 ? '#094274' :
            n > 100 ? '#1b5b93' :
            n > 50 ? '#467eb0' :
            '#6496c2'
    }
    return n > 1000 ? '#5627D8' :
        n > 500 ? '#6C43DD' :
        n > 250 ? '#825FE2' :
        n > 100 ? '#977AE7' :
        n > 50 ? '#AD96EC' :
        '#C3B2F1'
}

const getLabelColor = (n) => {
    return n > 1000 ? 'white' :
        n > 500 ? 'white' :
        n > 250 ? 'white' :
        n > 100 ? 'white' :
        n > 50 ? '#444444' :
        '#444444'
}

export const onClick = ({state}) => {
    show("offerings", {
        searchParams: {
            holdInvType:['M'],
            holdState: [state],
            persistToPreviousSearches: false,
            offeringType: ['ask-side'],
        },
        _ts: Date.now(),
        from:'municipals'
    })
}



// WEBPACK FOOTER //
// ./src/municipals/map/states-map.js